// extracted by mini-css-extract-plugin
module.exports = {"tooltipContent":"styles_tooltipContent__Rddrc"};